import { useState, useEffect, useContext } from "react";
import TopBanner from "common/Layout/Adverts/TopBanner";
import CenterWrapper from "Components/CenterWrapper";
import { InnerWrapper } from "./Search.styled";
import Catagories from "./Catagories";
import SearchRow from "./SearchRow";
import { FC } from "react";
import Results from "./Results";
import axios from "axios";
import { useRouter } from "next/dist/client/router";
import { PublicationContext } from "common/context/Publication";
import { publicationTypes } from "common/context/Publication/PublicationContext";

interface Props {
  terms: any;
}

export function removeEmpty(obj: any) {
  return Object.entries(obj)
    .filter(([_, v]) => v != null)
    .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});
}

interface State {
  offset: number;
  loading: boolean;
  total: number;
  q: any;
  results: [];
  start: any;
  end: number;
  dateQuery: string;
  searchQuery: string;
  searchTerm: string | string[];
  queryTerm: string;
  searchCatagory: {
    id?: string;
  };
  tids: string;
}
type AxiosResponse = {
  total: number;
  items: [];
};
const Search: FC<Props> = ({ terms }) => {
  const { publication } = useContext<publicationTypes>(PublicationContext);
  const { query } = useRouter();
  const [result, setResults] = useState<any>([]);
  const [total, setTotal] = useState<any>(0);
  const [state, setState] = useState<State>({
    offset: 0,
    loading: false,
    total: 0,
    q: "",
    results: [],
    dateQuery: "",
    start: 0,
    searchQuery: "",
    searchTerm: "",
    queryTerm: "",
    searchCatagory: {},
    tids: "",
    end: 0,
  });

  const handleChange = async (e: any) => {
    if (e.target.name === "q") {
      let searchParams = new URLSearchParams(window.location.search);
      searchParams.set("search", e.target.value);
      if (window.history.replaceState) {
        const url =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?" +
          searchParams.toString();

        window.history.replaceState(
          {
            path: url,
          },
          "",
          url
        );
      }
    }
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });

    const res = await axios.get(`/api/search`, {
      params: {
        q: e.target.value,
        publication,
      },
    });
    setResults(res.data.items);
    setTotal(res.data.total);
  };

  const handleInitialSearch = async () => {
    if (!query.search) {
      return null;
    }
    setState({
      ...state,
      loading: true,
    });
    const res = await axios.get<AxiosResponse>(`/api/search`, {
      params: {
        q: query.search,
        publication,
      },
    });
    setResults(res.data.items);
    setTotal(res.data.total);
    setState({
      ...state,
      q: query.search,
      searchTerm: query.search,
      results: res.data.items,
      total: res.data.total,
      dateQuery: "",
      offset: 10,
      loading: false,
      searchCatagory: {},
    });
  };
  useEffect(() => {
    if (query.search) {
      handleInitialSearch();
    }
  }, []);

  const handleSearchCatagory = async (item: { name: string; id: string }) => {
    if (state.searchTerm === "") {
      return null;
    }
    setState({
      ...state,
      loading: true,
    });

    const res = await axios.get<AxiosResponse>(`/api/search`, {
      params: {
        q: state.queryTerm,
        tids: item.id,
        publication,
        term: state.searchTerm,
      },
    });
    setResults(res.data.items);
    setTotal(res.data.total);
    //      //      ?&tids=${item.id}&term=${state.searchTerm}${state.dateQuery}&publication=${publication}`
    setState({
      ...state,
      offset: 0,
      searchCatagory: item,
      loading: false,
      tids: item.id,
    });
  };

  const handleSearchDates = async (start: number, end: number) => {
    if (state.q === "") {
      return null;
    }
    setState({
      ...state,
      loading: true,
      offset: 0,
    });
    const startDate =
      start !== null
        ? Math.round(
            new Date().setFullYear(new Date().getFullYear() - start, 0, 1) /
              1000
          )
        : Math.round((Date.now() - 12096e5) / 1000);
    const endDate =
      end !== null
        ? Math.round(
            new Date().setFullYear(new Date().getFullYear() - end, 0, 1) / 1000
          )
        : Math.round(Date.now() / 1000);
    setState({
      ...state,
      q: state.q,
      start: startDate,
      end: endDate,
    });

    const res = await axios.get<AxiosResponse>(`/api/search`, {
      params: {
        q: state.q,
        start: startDate,
        end: endDate,
        publication,
      },
    });
    setResults(res.data.items);
    setTotal(res.data.total ? res.data.total : 0);
    if (res.data.items) {
      setState({
        ...state,

        loading: false,
      });
    } else {
      setState({
        ...state,
        loading: false,
      });
    }
  };

  const getMoreResults = async () => {
    const params = removeEmpty({
      tids: state.tids,
      offset: state.offset,
      term: state.queryTerm,
      q: state.q,
      publication,
    });

    const res = await axios.get<AxiosResponse>(`/api/search`, {
      params,
    });

    if (res.data.items) {
      setResults((result: any) => [...result, ...res.data.items]);
      setTotal(res.data.total);
      setState({
        ...state,
        offset: state.offset + 10,
        results: [...state.results, ...res.data.items],
      });
    }
  };
  return (
    <>
      <CenterWrapper>
        <TopBanner />
        <InnerWrapper>
          <SearchRow total={total} handleChange={handleChange} state={state} />
          <Catagories
            terms={terms}
            handleSearchCatagory={handleSearchCatagory}
            handleSearchDates={handleSearchDates}
          />
          <Results
            getMoreResults={getMoreResults}
            total={total}
            results={result}
          />
        </InnerWrapper>
      </CenterWrapper>
    </>
  );
};

export default Search;
